import { Picture } from '../Picture/index';

export const Logo: React.FC<{ resourcesUrl: string }> = ({ resourcesUrl }) => {
  return (
    <Picture
      altText="Oddschecker Logo"
      height={34}
      priority
      webpSrc={`${resourcesUrl}/assets/img/OC_LOGO_2.webp?w=213&h=34&fm=webp&q=80`}
      width={213}
    />
  );
};
